import { Filters } from 'context/FilterProvider/types/Filters';

export const getNumberOfActiveFilters = (filters: Filters): number => {
  return Object.values(filters).reduce((count, filterArray) => count + filterArray.length, 0);
};
